import { useState, useEffect  } from 'react';
import styles from '../styles/body.module.scss'
import Box from '@mui/material/Box';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate } from 'react-router-dom';



export default function Success() {
  const navigate = useNavigate();

    // Only active while this component is mounted
    useEffect(() => {
      const handler = () => {
        navigate('/');
      };

      // Add listener
      window.addEventListener('popstate', handler);

      // Cleanup when component unmounts
      return () => {
        window.removeEventListener('popstate', handler);
      };
    }, [navigate]);
  

  return (

    <>
      <Box className={styles.successHeader} >
        <h1>Thank you for making an observation.</h1>
        </Box>
        <Box className={styles.header} >
        <div className={styles.successIcon}> 
        {<CheckCircleOutlineIcon fontSize="inherit"/>}
        </div>
        <h4 className={styles.successText}>This has been recorded and, if requested, Dandara management will be in touch to discuss your comments.</h4>
        </Box>


    </>
  );
}

